import React from 'react';
import { Text, View } from '@react-pdf/renderer';

interface SellerBuyerInfoProps {
  sellerInfo: {
    seller: string;
    sellerTaxCode: string;
    sellerAddress: string;
  };
  invoiceData: {
    orderNo?: string;
    buyerName?: string;
    paymentMethod?: string;
    identityCard?: string;
    passport?: string;
    company?: string;
    companyAddress?: string;
    taxCode?: string;
  };
}

const styles = {
  sellerContainer: {
    marginBottom: 8,
    borderBottom: '1px solid #333',
    paddingBottom: 8
  },
  buyerContainer: {
    marginBottom: 8,
    paddingBottom: 8
  },
  sellerBuyerContent: {
    marginLeft: 10
  },
  sellerBuyerText: {
    fontSize: 10,
    marginBottom: 3,
    lineHeight: 1.2
  },
  sellerBuyerLabel: {
    fontSize: 9
  },
  sellerBuyerValue: {
    fontSize: 9
  }
};

const SellerBuyerInfo: React.FC<SellerBuyerInfoProps> = ({ sellerInfo, invoiceData }) => (
  <>
    {/* Seller Information */}
    <View style={styles.sellerContainer}>
      <View style={styles.sellerBuyerContent}>
        <View style={{ flexDirection: 'row', lineHeight: 1.2, fontSize: 10, marginBottom: 3 }}>
          <Text style={styles.sellerBuyerLabel}>Đơn vị bán hàng (Seller): </Text>
          <Text
            style={{
              ...styles.sellerBuyerValue,
              color: '#eb0103',
              fontWeight: 'bold',
              fontSize: 10
            }}
          >
            {sellerInfo.seller}
          </Text>
        </View>
        <View style={{ flexDirection: 'row', lineHeight: 1.2, fontSize: 10, marginBottom: 3 }}>
          <Text style={styles.sellerBuyerLabel}>Mã số thuế (Tax code): </Text>
          <Text style={{ ...styles.sellerBuyerValue, fontWeight: 'bold' }}>
            {sellerInfo.sellerTaxCode}
          </Text>
        </View>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Địa chỉ (Address): </Text>
          <Text style={styles.sellerBuyerValue}>{sellerInfo.sellerAddress}</Text>
        </Text>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Điện thoại (Tel): </Text>
          <Text style={styles.sellerBuyerValue}></Text>
          <Text style={styles.sellerBuyerLabel}>Email: </Text>
          <Text style={styles.sellerBuyerValue}></Text>
        </Text>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Số tài khoản (A/C No): </Text>
          <Text style={styles.sellerBuyerValue}></Text>
        </Text>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Số đơn hàng (order Number): </Text>
          <Text style={styles.sellerBuyerValue}>{invoiceData.orderNo}</Text>
        </Text>
      </View>
    </View>

    {/* Buyer Information */}
    <View style={styles.buyerContainer}>
      <View style={styles.sellerBuyerContent}>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>
            Họ tên người mua hàng (Buyer&apos;s fullname):{' '}
          </Text>
          <Text style={{ ...styles.sellerBuyerValue, fontSize: 10 }}>{invoiceData.buyerName}</Text>
        </Text>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Tên đơn vị (Company&apos;s name): </Text>
          <Text style={styles.sellerBuyerValue}>{invoiceData.company || ''}</Text>
        </Text>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Địa chỉ (Address): </Text>
          <Text style={styles.sellerBuyerValue}>{invoiceData.companyAddress || ''}</Text>
        </Text>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Mã số thuế (Tax code): </Text>
          <Text style={styles.sellerBuyerValue}>{invoiceData.taxCode || ''}</Text>
        </Text>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Căn cước công dân (Identity Card): </Text>
          <Text style={styles.sellerBuyerValue}>{invoiceData.identityCard || ''}</Text>
          <Text style={styles.sellerBuyerLabel}>Số hộ chiếu (Passport): </Text>
          <Text style={styles.sellerBuyerValue}>{invoiceData.passport || ''}</Text>
        </Text>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Hình thức thanh toán (Payment method): </Text>
          <Text style={styles.sellerBuyerValue}>{invoiceData.paymentMethod}</Text>
        </Text>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Số tài khoản (A/C No): </Text>
          <Text style={styles.sellerBuyerValue}></Text>
        </Text>
        <Text style={styles.sellerBuyerText}>
          <Text style={styles.sellerBuyerLabel}>Tại (At): </Text>
          <Text style={styles.sellerBuyerValue}></Text>
        </Text>
      </View>
    </View>
  </>
);

export default SellerBuyerInfo;
